module.exports = new __parcel__URL__("live_page.21be0d2b.gif").toString();